import { Spinner, VStack } from "@gluestack-ui/themed";
import { useIdentityTypeInputController } from "./controller";
import { InputControlled } from "../InputControlled";
import { IdentityInputTypeEnum, IdentityTypeInputProps } from "./types";
import { ProductItem } from "../../core/ProductItem";
import { InputTypeSelect } from "@repo/core/components/forms/InputTypeSelect";

export const IdentityTypeInput = ({
  selectedInputType = IdentityInputTypeEnum.CPF,
  onChangeInputType,
  onSelectProduct,
  onFetchCard,
  onFetchProducts,
  onFetchCardFinish,
  onFetchProductsFinish,
  control,
  showProductsLoading = true,
  showCardExpiryInput = true,
  shouldFetchOnCardSubmit = true,
  onChangeCard,
  onChangeCPF
}: IdentityTypeInputProps) => {
  const {
    isMobile,
    products,
    isLoadingProducts,
    isLoadingProduct,
    handleSelectProduct,
    selectedProduct,
    debouncedHandleOnChangeCpf,
    debouncedHandleOnChangeCard
  } = useIdentityTypeInputController({
    selectedInputType,
    onChangeInputType,
    onSelectProduct,
    onFetchCard,
    onFetchProducts,
    onFetchCardFinish,
    onFetchProductsFinish,
    control,
    shouldFetchOnCardSubmit,
    onChangeCard,
    onChangeCPF
  });
  return (
    <VStack gap={24}>
      <InputTypeSelect
        selectedInputType={selectedInputType}
        onChangeInputType={onChangeInputType}
        isMobile={isMobile}
        inputTypes={[
          { label: "CPF", value: IdentityInputTypeEnum.CPF },
          { label: "Cartão", value: IdentityInputTypeEnum.CARD }
        ]}
      />
      {selectedInputType === IdentityInputTypeEnum.CARD && (
        <VStack gap={16}>
          <InputControlled
            control={control}
            name="card"
            placeholder="Insira o Número do Cartão"
            size="md"
            returnKeyType="done"
            keyboardType="number-pad"
            label="Número do cartão"
            isRequired={
              selectedInputType === IdentityInputTypeEnum.CARD ? true : false
            }
            mask="card"
            rightIcon={{ name: "credit-card", solid: true }}
            onChange={debouncedHandleOnChangeCard}
          />
          {showCardExpiryInput && (
            <InputControlled
              control={control}
              name="cardExpirationDate"
              placeholder="MM/AAAA"
              size="md"
              returnKeyType="next"
              label="Validade"
              keyboardType="number-pad"
              isRequired={
                selectedInputType === IdentityInputTypeEnum.CARD ? true : false
              }
              mask="cardDate"
            />
          )}
        </VStack>
      )}

      {selectedInputType === IdentityInputTypeEnum.CPF && (
        <VStack gap={16}>
          <InputControlled
            control={control}
            name="cpf"
            placeholder="Insira o seu CPF"
            size="md"
            returnKeyType="done"
            keyboardType="number-pad"
            label="CPF"
            isRequired={
              selectedInputType === IdentityInputTypeEnum.CPF ? true : false
            }
            mask="cpf"
            onChange={debouncedHandleOnChangeCpf}
          />
          {isLoadingProducts && showProductsLoading ? (
            <Spinner color="$primary700" />
          ) : (
            <VStack gap={16}>
              {products.map((product, index) => (
                <ProductItem
                  id={index.toString()}
                  key={index.toString()}
                  {...product}
                  isActive={index.toString() === selectedProduct}
                  isLoading={isLoadingProduct}
                  onPress={() => handleSelectProduct(index.toString())}
                />
              ))}
            </VStack>
          )}
        </VStack>
      )}
    </VStack>
  );
};
